import React from 'react'
import Link from 'next/link'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'hero-primary' | 'hero-secondary'
  size?: 'sm' | 'md' | 'lg'
  children: React.ReactNode
  href?: string
  className?: string
}

export default function Button({ 
  variant = 'primary', 
  size = 'md',
  children, 
  href,
  className = '',
  ...props 
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed active:scale-95'
  
  const variants = {
    primary: 'bg-ocean-600 text-white hover:bg-ocean-700 focus:ring-ocean-500 shadow-md hover:shadow-lg',
    secondary: 'bg-white text-ocean-600 border-2 border-ocean-600 hover:bg-ocean-50 focus:ring-ocean-500',
    ghost: 'bg-transparent text-gray-700 hover:bg-gray-100 focus:ring-gray-500',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 shadow-md hover:shadow-lg',
    'hero-primary': 'bg-white text-ocean-700 hover:bg-gray-100 hover:text-ocean-800 focus:ring-ocean-500 shadow-md hover:shadow-lg',
    'hero-secondary': 'bg-transparent text-white border-2 border-white hover:bg-white hover:text-ocean-700 focus:ring-white'
  }
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  }

  // Apply custom className last to override default styles
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`

  if (href) {
    return (
      <Link href={href} className={classes}>
        {children}
      </Link>
    )
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  )
}

